export const isContactNotFoundError = (error: unknown): boolean => {
  if (!(error instanceof Error)) return false;

  const message = error.message.toLowerCase();
  return (
    message.includes('not found') ||
    message.includes('404') ||
    message.includes('does not exist')
  );
};
